import { OutputData } from '@editorjs/editorjs'

import { IBase, IBaseSeo, IImage, SECTION_THEME_ENUM } from './base'
import { IEmployeeReduced } from './employee'
import { IInsuranceCompanyReduced } from './insurance-company'
import { IPriceListGroup, IPriceListItem } from './price-list'
import { IWorkplaceReduced } from './workplace'

export enum HERO_TYPE_ENUM {
	NOTICE = 'NOTICE',
	IMAGE = 'IMAGE'
}

export enum AMBULANCE_PRICE_LIST_TABLE_TYPE {
	DEFAULT = 'DEFAULT',
	PLUS_WITH_AND_WITHOUT_YEAR_PROGRAM_PRICE = 'PLUS_WITH_AND_WITHOUT_YEAR_PROGRAM_PRICE',
	PLUS_DEFAULT_PRICE_FOR_INSURED = 'PLUS_DEFAULT_PRICE_FOR_INSURED'
	// PLUS_INSURANCE_PRICE = 'PLUS_INSURANCE_PRICE'
}

export interface IProductListBanner {
	uuid: string
	title: string
	text: string
	buttonText?: string
	buttonLink?: string
	isEnabled: boolean
	sortOrder: number
	icon?: React.ReactNode
}

export interface IAmbulanceSitemap {
	slug: string
	updatedAt: string
}

export interface IAmbulanceRootCategory {
	id: number
	name: string
	nameSingular: string
	slug: string
	sectionTheme: SECTION_THEME_ENUM
	type: string
	isSubpage: boolean
}

export interface IAmbulanceReduced extends IBase {
	name: string
	slug: string
	rootCategory?: IAmbulanceRootCategory | null
}

export interface IAmbulance extends IAmbulanceReduced, IBaseSeo {
	aboutAbout: OutputData
	aboutBenefits: OutputData
	aboutContent: OutputData
	aboutService: OutputData
	aboutExaminationProcess: OutputData
	contentImages: IImage[]
	description: string
	employees: IEmployeeReduced[]
	hasOrderableTemplates: boolean
	hasOrderableProducts: boolean
	heroImage: IImage
	heroText: string | null
	heroTitle: string | null
	heroButtonText: string | null
	heroButtonLink: string | null
	heroType: HERO_TYPE_ENUM | null
	insuranceCompanies: IInsuranceCompanyReduced[]
	priceListGroups: IPriceListGroup[]
	priceListItems: IPriceListItem[]
	workplaces: IWorkplaceReduced[]
	image: IImage
	priceListTableType: AMBULANCE_PRICE_LIST_TABLE_TYPE
	productListBanners?: IProductListBanner[]
}
